import type { IconSvgObject } from './types';

const Location10Icon: IconSvgObject = [
  ["path", { d: "M18 19C18 20.6569 15.3137 22 12 22C8.68629 22 6 20.6569 6 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.5 9C14.5 10.3807 13.3807 11.5 12 11.5C10.6193 11.5 9.5 10.3807 9.5 9C9.5 7.61929 10.6193 6.5 12 6.5C13.3807 6.5 14.5 7.61929 14.5 9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 2C8.13401 2 5 5.07518 5 8.8686C5 12.8958 8.6928 14.9584 11.0836 17.7656C11.5528 18.3166 12.468 18.3311 12.946 17.7878C15.374 15.0281 19 12.8174 19 8.8686C19 5.07518 15.866 2 12 2Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Location10Icon;
